import { PlacementXAnchor, PlacementYAnchor, AnnotationFillType } from "building-types/annotation/annotationTypesEnum";
import type { DXFUnit } from "building-types/assets/dxf";
import { ONE_INCH } from "common/constants/scaleFactors";
import type { OneHundredthMillimeters } from "common/types/nominalNumbersTypes";
import { oneHundredthMillimetersToInches, sheetInchesToPoints } from "common/utils/nominalNumbers";
import type { SheetGeometryStyleSheet } from "./primitives/primitiveStylesTypes";

export const DXF_MTEXT_ANCHORS: Record<number, [PlacementXAnchor, PlacementYAnchor]> = {
  1: [PlacementXAnchor.LEFT, PlacementYAnchor.TOP],
  2: [PlacementXAnchor.CENTER, PlacementYAnchor.TOP],
  3: [PlacementXAnchor.RIGHT, PlacementYAnchor.TOP],
  4: [PlacementXAnchor.LEFT, PlacementYAnchor.CENTER],
  5: [PlacementXAnchor.CENTER, PlacementYAnchor.CENTER],
  6: [PlacementXAnchor.RIGHT, PlacementYAnchor.CENTER],
  7: [PlacementXAnchor.LEFT, PlacementYAnchor.BOTTOM],
  8: [PlacementXAnchor.CENTER, PlacementYAnchor.BOTTOM],
  9: [PlacementXAnchor.RIGHT, PlacementYAnchor.BOTTOM],
  0: [PlacementXAnchor.LEFT, PlacementYAnchor.TOP],
};

export const DXF_PLACEMENT_X_ANCHOR: Record<number, PlacementXAnchor> = {
  0: PlacementXAnchor.LEFT,
  1: PlacementXAnchor.LEFT,
  2: PlacementXAnchor.CENTER,
  3: PlacementXAnchor.RIGHT,
};

export const DXF_PLACEMENT_Y_ANCHOR: Record<number, PlacementYAnchor> = {
  0: PlacementYAnchor.BOTTOM,
  1: PlacementYAnchor.BOTTOM,
  2: PlacementYAnchor.CENTER,
  3: PlacementYAnchor.TOP,
};

export const DXF_HATCH_PATTERNS = {
  ANSI31: AnnotationFillType.DIAGONAL_UP,
  ANSI37: AnnotationFillType.DIAGONAL_UP,
  SOLID: AnnotationFillType.SOLID_20PCT_GRAY,
} as const;

export const DXF_UNIT_CODES: Record<number, DXFUnit> = {
  0: "Unitless", // No specific units defined
  1: "Inches",
  2: "Feet",
  3: "Miles",
  4: "Millimeters",
  5: "Centimeters",
  6: "Meters",
  7: "Kilometers",
  8: "Microinches", // (1/1,000,000 inch)
  9: "Mils", // (1/1000 inch)
  10: "Yards",
  11: "Angstroms", // (1/10^-10 meter)
  12: "Nanometers",
  13: "Microns", // (1/1,000,000 meter)
  14: "Decimeters",
  15: "Decameters",
  16: "Hectometers",
  17: "Gigameters",
  18: "Astronomical Units",
  19: "Light Years",
  20: "Parsecs",
};

export const DXF_ACAD_LINEWEIGHT_VALUES: OneHundredthMillimeters[] = [
  0, 5, 9, 13, 15, 18, 20, 25, 30, 35, 40, 50, 53, 60, 70, 80, 90, 100, 106, 120, 140, 158, 200, 211,
] as OneHundredthMillimeters[];

export const DXF_LINEWEIGHT_DEFAULT = sheetInchesToPoints(
  oneHundredthMillimetersToInches(25 as OneHundredthMillimeters),
); // 0.25 mm;

// These are set here to match normal viewer supplied values for DXF files
export const DXF_DEFAULT_STYLESHEET: SheetGeometryStyleSheet = {
  line: {
    linewidth: DXF_LINEWEIGHT_DEFAULT,
  },
  text: {
    fontSize: ONE_INCH,
  },
};
